var render = function render(){var _vm=this,_c=_vm._self._c;return _c('zingchart',{ref:"chart",attrs:{"data":_vm.HeadCountSegAnalysisDeptData}})
}
var staticRenderFns = []

export { render, staticRenderFns }